import React, { createContext, useContext, useEffect, useState } from "react";
import { getHeardAboutUs } from "services/heardAboutUs-service";
import { useUsers } from "./UserContext";
import { hearAboutUsOptions } from "constants/data";

export const HeardAboutUsContext = createContext();

export const HeardAboutUsProvider = ({ children }) => {
  const { userData } = useUsers();
  const [feedbackUsers, setFeedbackUsers] = useState([]);
  const [filter, setFilter] = useState("unresolved");

  const [feedBackByType, setFeedBackByType] = useState([]);

  const [startFetchHeardAboutUs, setStartFetchHeardAboutUs] = useState(false);

  useEffect(() => {
    if (!startFetchHeardAboutUs || !userData.length) return;
    getHeardAboutUs(setFeedbackUsers, userData);
  }, [startFetchHeardAboutUs, userData]);

  useEffect(() => {
    if (!feedbackUsers.length) return;
    // initialize all types with 0, then count
    const initialized = hearAboutUsOptions.map((opt) => ({ hearAboutUs: opt.id, count: 0 }));
    feedbackUsers.forEach((item) => {
      const type = item.hearAboutUs;
      const idx = initialized.findIndex((x) => x.hearAboutUs === type);
      if (idx !== -1) initialized[idx].count++;
    });
    const sorted = initialized.sort((a, b) => (a.count < b.count ? 1 : -1));
    setFeedBackByType(sorted);
  }, [feedbackUsers]);

  return (
    <HeardAboutUsContext.Provider
      value={{
        filter,
        setFilter,
        feedbackUsers,
        setFeedbackUsers,
        feedBackByType,
        setStartFetchHeardAboutUs
      }}
    >
      {children}
    </HeardAboutUsContext.Provider>
  );
};

export const useHeardAboutUs = () => useContext(HeardAboutUsContext);
